var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":`${_vm.$t('edit')} ${_vm.$t('order')}`}},[_c('BaseButton',{staticClass:"btn-link btn-warning",attrs:{"icon":"","size":_vm.size},on:{"click":_vm.openOrderDialog}},[_c('i',{staticClass:"fas fa-cog"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }